module.exports = __webpack_public_path__ + "static/media/miysis_3d_cdcl_dpp_int-hall01-fixe_final-perso.29fb1f03.jpg";